import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { provideClientHydration, withEventReplay, withIncrementalHydration } from '@angular/platform-browser';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, './assets/i18n/', '.json');

const requiredModule = [
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: httpLoaderFactory,
      deps: [HttpClient],
    },
  }),
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor]),
    ),
    ...requiredModule.map(i => importProvidersFrom(i)),
    {
      provide: LOCALE_ID,
      useValue: 'en-US',
    },
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: {
        dateFormat: 'dd/MM/yyyy HH:mm:ss O',
        timezone: 'GMT+7',
      },
    },
    // Incremental: `@defer (hydrate ...)` blocks (landing sections below the fold)
    // hydrate later in small chunks instead of in one long startup task.
    provideClientHydration(withEventReplay(), withIncrementalHydration()),
  ],
};
